class FAQAccordion extends HTMLElement {
  constructor() {
    super();
    this.detailsElements = this.querySelectorAll('details');
  }

  connectedCallback() {
    this.openFirstAccordion();
    this.detailsElements.forEach((details) => {
      const summary = details.querySelector('summary');
      const content = details.querySelector('.accordion-content');

      details.animation = null;
      details.isClosing = false;
      details.isExpanding = false;

      summary.addEventListener('click', (e) => this.onClick(e, details, summary, content));
    });
  }

  openFirstAccordion() {
    if (this.hasAttribute('open-first')) {
      const firstDetails = this.detailsElements[0];
      if (firstDetails) firstDetails.open = true;
    }
  }

  onClick(e, details, summary, content) {
    e.preventDefault();
    details.style.overflow = 'hidden';
    if (details.isClosing || !details.open) {
      this.open(details, summary, content);
    } else if (details.isExpanding || details.open) {
      this.shrink(details, summary);
    }

    if (this.hasAttribute('open-one')) {
      this.closeOtherAccordions(details);
    }
  }

  shrink(details, summary) {
    details.isClosing = true;

    const startHeight = `${details.offsetHeight}px`;
    const endHeight = `${summary.offsetHeight}px`;

    if (details.animation) {
      details.animation.cancel();
    }

    details.animation = details.animate(
      {
        height: [startHeight, endHeight],
      },
      {
        duration: 200,
        easing: 'ease-in',
      },
    );

    details.animation.onfinish = () => this.onAnimationFinish(details, false);
    details.animation.oncancel = () => (details.isClosing = false);
  }

  open(details, summary, content) {
    details.style.height = `${details.offsetHeight}px`;
    details.open = true;
    window.requestAnimationFrame(() => this.expand(details, summary, content));
  }

  expand(details, summary, content) {
    details.isExpanding = true;
    const startHeight = `${details.offsetHeight}px`;
    const endHeight = `${summary.offsetHeight + content.offsetHeight}px`;

    if (details.animation) {
      details.animation.cancel();
    }

    details.animation = details.animate(
      {
        height: [startHeight, endHeight],
      },
      {
        duration: 200,
        easing: 'ease-in',
      },
    );
    details.animation.onfinish = () => this.onAnimationFinish(details, true);
    details.animation.oncancel = () => (details.isExpanding = false);
  }

  onAnimationFinish(details, open) {
    details.open = open;
    details.animation = null;
    details.isClosing = false;
    details.isExpanding = false;
    details.style.height = details.style.overflow = '';
  }

  closeOtherAccordions(openDetails) {
    this.detailsElements.forEach((details) => {
      if (details !== openDetails && details.open) {
        this.shrink(details, details.querySelector('summary'));
      }
    });
  }
}

customElements.define('faq-accordion', FAQAccordion);
